import React from 'react';

const BusinessIncubator = () => {
  return (
    <div>
      <section className="page-hero">
        <h1>Business Incubator</h1>
        <p>Nurturing the next generation of African businesses</p>
      </section>
      <section className="page-content">
        <div className="container">
          <p style={{fontSize: '1.1rem', lineHeight: '1.8', color: '#E6D88A'}}>
            Our business incubator program provides mentorship, funding opportunities, 
            and resources to help startups and early-stage businesses thrive.
          </p>
          <div className="content-grid" style={{marginTop: '30px'}}>
            <div className="content-card">
              <h3>Mentorship</h3>
              <p>Guidance from experienced business leaders.</p>
            </div>
            <div className="content-card">
              <h3>Funding Access</h3>
              <p>Connections to investors and funding sources.</p>
            </div>
            <div className="content-card">
              <h3>Workspace</h3>
              <p>Co-working spaces and resources.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default BusinessIncubator;